import {ref, isRef, watchEffect} from "vue";

/**
 * Get the questions with ratings for this product
 * @param product
 * @returns {{getQuestions: ((function(): Promise<void>)|*), questions: Ref<UnwrapRef<*[]>>, loading: Ref<UnwrapRef<boolean>>}}
 */
export function useProductQuestions(product) {
    const questions = ref([]);
    const loading = ref(false);

    async function getQuestions() {
        loading.value = true;

        const response = await axios.get(`/products/${product.identifier}/questions`);

        questions.value = response.data;
        loading.value = false;
    }

    if (isRef(product)) {
        watchEffect(getQuestions);
    } else {
        getQuestions();
    }

    return {questions, loading, getQuestions};
}

export function useCompetitionProduct(product) {
    const competition = ref(null);
    const loading = ref(false);

    async function getCompetition() {
        loading.value = true;

        const response = await axios.get(route("products.competition", product));

        loading.value = false;
        competition.value = response.data;
    }

    isRef(product) ? watchEffect(getCompetition) : getCompetition();

    return {
        product: competition,
        loading
    };
}
